class ShopifyTabs {
    constructor() {
        this.init();
    }

    init() {
        // Wait for DOM to be ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.setupTabs();
            });
        } else {
            this.setupTabs();
        }
    }

    setupTabs() {
        // Get all tab buttons (updated class name)
        this.tabButtons = document.querySelectorAll('.tabs-navigation__button');
        // Get all tab content sections (updated class name)
        this.tabContents = document.querySelectorAll('.section-tabs-content');

        if (this.tabButtons.length === 0 || this.tabContents.length === 0) {
            console.warn('ShopifyTabs: No tab buttons or content sections found');
            return;
        }

        // Add click event listeners to tab buttons
        this.tabButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                this.handleTabClick(e);
            });
        });

        // Show first tab by default
        this.showFirstTab();

        console.log('ShopifyTabs initialized successfully');
    }

    handleTabClick(event) {
        const clickedButton = event.currentTarget;
        const targetTabId = clickedButton.getAttribute('data-tab');
        const targetTabIndex = clickedButton.getAttribute('data-tab-index');

        if (!targetTabId) {
            console.warn('ShopifyTabs: No data-tab attribute found on button');
            return;
        }

        // Remove active class from all buttons (updated class name)
        this.tabButtons.forEach(btn => {
            btn.classList.remove('tabs-navigation__button--active');
        });

        // Add active class to clicked button (updated class name)
        clickedButton.classList.add('tabs-navigation__button--active');

        // Hide all tab content sections (updated class name)
        this.tabContents.forEach(content => {
            content.classList.remove('section-tabs-content--active');
        });

        // Show target tab content
        this.showTabContent(targetTabId, targetTabIndex);

        // Scroll to content (optional)
        this.scrollToContent();
    }

    showTabContent(tabId, tabIndex) {
        // Find ALL content sections that match the tab ID or index
        let targetContents = [];
        
        // Try to find content by tab ID first
        targetContents = document.querySelectorAll(`[data-tab-content="${tabId}"]`);
        
        // If not found by ID, try by index
        if (targetContents.length === 0 && tabIndex) {
            targetContents = document.querySelectorAll(`[data-tab-index="${tabIndex}"]`);
        }

        if (targetContents.length > 0) {
            // Add active class to ALL matching content sections (updated class name)
            targetContents.forEach(content => {
                content.classList.add('section-tabs-content--active');
                
                // Add fade-in animation
                content.style.opacity = '0';
                setTimeout(() => {
                    content.style.opacity = '1';
                }, 10);
            });
        } else {
            console.warn(`ShopifyTabs: Could not find content for tab "${tabId}" (index: ${tabIndex})`);
        }
    }

    showFirstTab() {
        // Ensure first tab is active on page load
        const firstButton = this.tabButtons[0];
        const firstContent = this.tabContents[0];

        if (firstButton && firstContent) {
            // Updated class names
            firstButton.classList.add('tabs-navigation__button--active');
            firstContent.classList.add('section-tabs-content--active');
        }
    }

    scrollToContent() {
        // Optional: Scroll to the first active tab content section (updated class name)
        const activeTabContent = document.querySelector('.section-tabs-content.section-tabs-content--active');
        if (activeTabContent) {
            const offset = 100; // Adjust this value as needed
            const elementPosition = activeTabContent.offsetTop;
            const offsetPosition = elementPosition - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    }

    // Public method to programmatically switch tabs
    switchToTab(tabId) {
        const targetButton = document.querySelector(`[data-tab="${tabId}"]`);
        if (targetButton) {
            targetButton.click();
        }
    }

    // Public method to get current active tab (updated class name)
    getCurrentTab() {
        const activeButton = document.querySelector('.tabs-navigation__button--active');
        return activeButton ? activeButton.getAttribute('data-tab') : null;
    }

    // Refresh/reinitialize tabs (useful for dynamic content)
    refresh() {
        this.setupTabs();
    }
}

// Initialize tabs when script loads
let shopifyTabs;

// Function to initialize tabs
function initShopifyTabs() {
    shopifyTabs = new ShopifyTabs();
}

// Auto-initialize
initShopifyTabs();

// Make it available globally for manual initialization if needed
window.ShopifyTabs = ShopifyTabs;
window.shopifyTabs = shopifyTabs;

// Theme editor compatibility (for Shopify theme customizer)
if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
        // Reinitialize tabs when sections are loaded in theme editor
        setTimeout(() => {
            if (shopifyTabs) {
                shopifyTabs.refresh();
            } else {
                initShopifyTabs();
            }
        }, 100);
    });

    document.addEventListener('shopify:section:reorder', function (event) {
        // Reinitialize tabs when sections are reordered
        setTimeout(() => {
            if (shopifyTabs) {
                shopifyTabs.refresh();
            }
        }, 100);
    });
}